// extracted by mini-css-extract-plugin
module.exports = {"logosWrapper":"logos-module--logos-wrapper--p7VHt","logos":"logos-module--logos--1l3XP","logos__logo":"logos-module--logos__logo--350Ru"};